import { useEffect, useState } from 'react';
const useGlobalIncidents = () => {
    const [data, setData] = useState();
    useEffect(() => {
        let isMounted = true;
        fetch('https://zapier.com/api/v3/support/incidents')
            .then(res => res.json())
            .then(({ objects }) => {
            if (isMounted && Array.isArray(objects) && objects.length > 0) {
                setData(objects.map(incident => (Object.assign(Object.assign({}, incident), { iconApp: null }))));
            }
        });
        return () => {
            isMounted = false;
        };
    }, []);
    return {
        data,
    };
};
export default useGlobalIncidents;
